module.exports = __webpack_public_path__ + "img/nl.390aa40f.svg";